import React, {Component} from 'react'
import ReactSelect from 'react-select'
import _ from 'lodash'
import LinkWithTooltip from '../../tooltip';

class Module extends Component {

  constructor(props) {
    super(props);

    this.state ={
      options: [],
      value: '',
      multi: this.props.params.multiple
    }
  }

  componentDidMount(){

    const { params } = this.props;
    if ( params.module == 'position') {
      this.setState({ options : moduleAttr.modulePosition })
    } else {
      this.setState({ options : moduleAttr.moduleName })
    }
  }

  logChange(val){
    const { input: { value, onChange, name } } = this.props

    this.setState({
      value: val
    })

    if (typeof val.length != 'undefined') {
      var arrayVal = [];
      for (var i = 0; i < val.length; i++) {
        arrayVal[i] = val[i].value;
      }
      onChange( arrayVal );
    } else {
      onChange( val.value );
    }
  }

  render(){
    const { input, params } = this.props

    return(
      <div className="sp-pagebuilder-form-group" >
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <ReactSelect
          name={ input.name }
          value={ this.props.input.value }
          multi={ this.state.multi }
          options={ this.state.options }
          onChange={ this.logChange.bind(this) }
        />
      </div>
    )
  }
}

export default Module;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Module.js